// src/domains/auth/auth.store.ts

import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

import {
  setCookie,
  getCookie,
  removeCookie,
} from '@/domains/auth/utils/cookies';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { useConfigStore } from '@/config/config.store';
import { customStorage } from '@/shared/lib/storage';
import { registerClear } from '@/shared/lib/storesRegistry';

// hasCustomer temporary commented
interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  // hasCustomer: boolean;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearTokens: () => void;
}

export function handleDemoUser(isDemo: boolean) {
  const setMswFlag = useConfigStore.getState().setMswFlag;

  if (isDemo) {
    setMswFlag('auth', true);
    setMswFlag('user', true);
  }
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        accessToken: getCookie('accessToken') || null,
        refreshToken: getCookie('refreshToken') || null,
        // hasCustomer: false,
        setTokens: (accessToken, refreshToken) => {
          try {
            set({ accessToken, refreshToken });
            setCookie('accessToken', accessToken);
            setCookie('refreshToken', refreshToken);
            const decoded = jwtDecode<JwtPayload>(accessToken);
            if (decoded.exp) {
              setCookie('expireAt', (decoded.exp * 1000).toString());
            }
          } catch (error) {
            console.error('Error setting tokens:', error);
          }
          return Promise.resolve(); // Ensures that the state is synchronized
        },
        clearTokens: () => {
          set({ accessToken: null, refreshToken: null });
          removeCookie('accessToken');
          removeCookie('refreshToken');
          removeCookie('expireAt');
        },
      }),
      {
        name: 'auth-storage',
        storage: customStorage,
        partialize: () => ({
          accessToken: undefined, // Don't persist it in localStorage
          refreshToken: undefined, // Don't persist it in localStorage
          setTokens: undefined,
          clearTokens: undefined,
        }),
      },
    ),
    { name: 'AuthStore' },
  ),
);

registerClear(useAuthStore.getState().clearTokens);
